import { render } from "./order-price.vue?vue&type=template&id=425adf77&scoped=true&ts=true"
import script from "./order-price.vue?vue&type=script&lang=ts"
export * from "./order-price.vue?vue&type=script&lang=ts"

import "./order-price.vue?vue&type=style&index=0&id=425adf77&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425adf77"]])

export default __exports__